var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showBanner)?_c('div',{staticClass:"container text-center environment-banner-container"},[_c('b-nav-text',{staticClass:"environment-banner"},[_vm._v(" You are currently in the "+_vm._s(_vm.instance)+" Environment. ")])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }